import { render, staticRenderFns } from "./AccountReceive.vue?vue&type=template&id=05e821e1&"
import script from "./AccountReceive.vue?vue&type=script&lang=js&"
export * from "./AccountReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports